<template>
    <div class="menu" transition="menu-side">
        <a @click="onNavClick(null)" class="menu-all">全部 <span class="all-span"></span></a>
        <ul class="menu-list">
            <li v-for="item in menuList" >
                <a :class="{'active' : cateid == item.cateid }" @click="onNavClick(item.cateid)">
                    <span class="menu-keyword">{{item.cateName}}</span>
                    <span class="menu-keyinfo">{{item.subName}}</span>
                </a>
            </li>
        </ul>
    </div>
</template>
<style lang="less">
    @import "Menu.less";
</style>
<script>
    module.exports = {
        props: ['menuList','cateid','isShowMenu'],
        methods: {
            onNavClick: function (cateid) {
                this.isShowMenu = false;
                this.$dispatch('change',cateid);
            }
        }
    }
</script>



/** WEBPACK FOOTER **
 ** Menu.vue?60036c9e
 **/